import { graphClient } from "../graph-client";
import { GET_AGENCY_FIRST } from "./gql";
import { GetFirst } from "./types";

class AgencyService {
  async getFirst(params: GetFirst.Input) {
    const request = await graphClient.request<GetFirst.Output>(
      GET_AGENCY_FIRST,
      { ...params }
    );

    return request?.getAgencyFirst;
  }
}

export const agencyService = new AgencyService();
